import { useCallback } from 'react';

import log from 'loglevel';

import {
  useGetSnoozedEmails,
  useUnsnoozeEmail,
} from '../../../services/snoozedEmails.service';
import { FETCH_POLICY_CACHE_FIRST } from '../../../utils/constants';

export const useCancelSnoozeOnRemoval = () => {
  const { snoozedEmails } = useGetSnoozedEmails(FETCH_POLICY_CACHE_FIRST);
  const { unsnoozeEmail } = useUnsnoozeEmail();

  const cancelSnoozeFor = useCallback(
    (messageIds: string[]) => {
      const messageIdSet = new Set(messageIds);
      const snoozesToCancel = snoozedEmails.filter((snoozedEmail) =>
        messageIdSet.has(snoozedEmail.messageId),
      );

      if (snoozesToCancel.length === 0) {
        return;
      }

      Promise.all(
        snoozesToCancel.map((snoozedEmail) =>
          unsnoozeEmail(snoozedEmail.snoozeId),
        ),
      ).catch((error) => {
        log.error('useCancelSnoozeOnRemoval: failed to cancel snooze', {
          error,
        });
      });
    },
    [snoozedEmails, unsnoozeEmail],
  );

  return { cancelSnoozeFor };
};
